<template>
  <v-card-text>
    <!-- Page Header -->
    <v-card class="custom-card px-4 py-2 mb-2">
      <v-row density="compact">
        <v-col cols="12" sm="6" md="6">
          <v-chip-group
            v-model="filterStatus"
            selected-class="bg-primary text-white border-primary"
            mandatory
          >
            <v-chip
              v-for="status in statusFilters"
              :key="status.value"
              :value="status.value"
              variant="outlined"
              color="white"
              class="font-weight-bold px-4"
            >
              {{ status.title }}
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="d-flex justify-end">
          <!-- <v-select
            variant="outlined"
            density="compact"
            color="primary"
            max-width="280"
            :items="[
              {
                title: 'Pending',
                value: 'PENDING',
              },
              {
                title: 'Approved',
                value: 'APPROVED',
              },
              {
                title: 'Rejected',
                value: 'REJECTED',
              },
            ]"
            v-model="filterStatus"
            hide-details
            label="Filter By Status"
          ></v-select> -->
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-card class="custom-card">
        <v-data-table
          :headers="headers"
          :items="GetALLFlaggedPollsList"
          :itemsPerPage="itemsPerPage"
          :height="vuetifyObject?.height - 205"
          v-model:page="page"
          class="elevation-0"
          density="compact"
          hide-default-footer
          :loading="loading"
          :items-per-page="10"
          @click:row="viewFlaggedPoll"
        >
          <template v-slot:[`item.poll_details`]="{ item }">
            <div class="font-weight-600">{{ item.poll_details.title }}</div>
          </template>

          <template v-slot:[`item.workflow_status`]="{ item }">
            <v-chip
              :color="
                item.workflow_status === 'PENDING'
                  ? 'warning'
                  : item.workflow_status === 'APPROVED'
                  ? 'success'
                  : 'error'
              "
              size="small"
              class="font-weight-bold"
            >
              {{ item.workflow_status }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex gap-2">
              <v-menu v-if="item.workflow_status == 'PENDING'">
                <template v-slot:activator="{ props }">
                  <v-btn
                    size="small"
                    variant="text"
                    icon="mdi-dots-vertical"
                    v-bind="props"
                  ></v-btn>
                </template>
                <v-list density="compact" class="text-subtitle">
                  <v-list-item
                    title="Approve/Reject"
                    @click="viewFlaggedPoll(false, { item })"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="warning"
                        icon="mdi-shield-check"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon v-else color="primary">mdi-eye</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-pagination
          density="compact"
          :length="pageCount"
          v-model="page"
        ></v-pagination>
      </v-card>
    </div>
    <ViewFlaggedPollsDialog
      v-model:dialog="showDialog"
      :request="selectedPoll"
      @clicked="ViewFlaggedPollsDialogEmit"
    />
  </v-card-text>
</template>

<script>
import { ListAllWorkflows } from "@/mixins/Extras/ListAllWorkflows";
import ViewFlaggedPollsDialog from "@/components/FlaggedPolls/Dialogs/ViewFlaggedPollsDialog.vue";

export default {
  name: "RequestToPollPage",
  components: {
    ViewFlaggedPollsDialog,
  },
  props: {
    vuetifyObject: {
      type: Object,
      required: false,
    },
  },
  mixins: [ListAllWorkflows],
  data() {
    return {
      itemsPerPage: 100,
      page: 1,
      searchQuery: "",
      selectedSort: "newest",
      filterStatus: "PENDING",
      statusFilters: [
        {
          title: "Pending",
          value: "PENDING",
        },
        {
          title: "Approved",
          value: "APPROVED",
        },
        {
          title: "Rejected",
          value: "REJECTED",
        },
      ],
      loading: false,
      showDialog: false,
      selectedPoll: {},
      headers: [
        { title: "Poll Title", key: "poll_details", width: "30%" },
        { title: "Status", key: "workflow_status", width: "15%" },
        { title: "Comments", key: "comment", width: "40%" },
        { title: "Actions", key: "actions", sortable: false, width: "15%" },
      ],
      GetALLFlaggedPollsList: [],
    };
  },
  async mounted() {
    this.GetALLFlaggedPollsList = await this.GetAllWorkflowsMethod(
      this.filterStatus,
      "POLL_REPORT",
    );
  },
  computed: {
    pageCount() {
      return Math.ceil(this.GetALLFlaggedPollsList?.length / this.itemsPerPage);
    },
  },
  watch: {
    async filterStatus(newStatus) {
      this.GetALLFlaggedPollsList = await this.GetAllWorkflowsMethod(
        newStatus,
        "POLL_REPORT",
      );
    },
  },
  methods: {
    viewFlaggedPoll(row, poll) {
      this.selectedPoll = poll.item;
      this.showDialog = true;
    },
    async ViewFlaggedPollsDialogEmit(Toggle) {
      if (Toggle == 2) {
        this.GetALLFlaggedPollsList = await this.GetAllWorkflowsMethod(
          this.filterStatus,
          "POLL_REPORT",
        );
      }
    },
  },
};
</script>
<style></style>
